import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpContextToken } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HttpErrorsService } from '../services/http-errors.service';

export const STATUS_TO_SILENCE = new HttpContextToken<number[]>(() => []);

@Injectable()
export class HttpErrorsInterceptor implements HttpInterceptor {

 
  constructor( private handleHttpErrorsService: HttpErrorsService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request)
    .pipe(
      tap({
        error: (error: HttpErrorResponse) => {
          const silentStatus = request.context.get(STATUS_TO_SILENCE);
          !silentStatus.includes(error?.status) && this.handleHttpErrorsService.handleHttpError(error);
        }
      })
    );
  }
}
